export default "__VITE_ASSET__Bk4nIBP7__"